import React, { useCallback, useEffect, useState } from "react";
import SearchContainerWithPermission from "../search-container/SearchContainerWithPermission";
import { caseEditAction, caseResetAction, caseSearchAction } from "./actions/CaseActions";
import { DATA_TYPE, DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { UnAuthorizedErrorPage } from "src/utils/CommonUtils";
import RoutingUtil from "src/utils/RoutingUtil";
import { Formik, Form } from "formik";
import FormikSelect from "src/components/formik/FormikSelect";
import {
  PRODUCT_CATEGORY_TYPES_LIST,
  CAR_LOAN_TYPE_LIST,
  USED_CAR_LOAN_TYPE_LIST,
} from "../product-container/ProductConstants";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import CustomerDropDown from "src/business-components/CustomerDropDown";
import FormikInput from "src/components/formik/FormikInput";
import { EMPLOYMENT_TYPES_LIST } from "../user-container/UserConstants";
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import { isProduction } from "src/config/index";
import { withFormikDevtools } from "formik-devtools-extension";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import { set } from "lodash";
import { userSearchAPI } from "src/api/UserApi";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import FormikToggle from "src/components/formik/FormikToggle";

const Render = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }
  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    // forceRefreshSearchContainer,
    resetForm,
    where,
    values,
  
  } = props;

  return (
    <div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form>
            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Category</label>
                <FormikSelect
                  items={PRODUCT_CATEGORY_TYPES_LIST}
                  name="productCategory"
                  className="form-control"
                />
              </div>
              {values.productCategory === "CAR_LOAN" && (
                <div className="form-group col-md-3">
                  <label>Loan Type</label>
                  <FormikSelect
                    items={CAR_LOAN_TYPE_LIST}
                    name="loanType"
                    className="form-control"
                  />
                </div>
              )}
              {values.productCategory === "CAR_LOAN" && values.loanType === "USED" && (
                <div className="form-group col-md-3">
                  <label>Used Car Loan Type</label>
                  <FormikSelect
                    items={USED_CAR_LOAN_TYPE_LIST}
                    name="usedCarLoanType"
                    className="form-control"
                  />
                </div>
              )}
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="CaseFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="CaseToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Company</label>
                <CompanyDropDown name="companyId"
                  value={values.companyId}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Frontend Manager</label>
                <UserDropDown name="reportingManagerId" value={values.reportingManagerId} />
              </div>
              <div className="form-group col-md-3">
                <label>BackendManager</label>
                <UserDropDown name="reportingManagerBackendId" value={values.reportingManagerBackendId} />
              </div>
              <div className="form-group col-md-3">
                <label>Assigned Agent</label>
                <UserDropDown name="agentId"
                  value={values.agentId}
                />
              </div>

              <div className="form-group col-md-3">
                <label>Customer</label>
                <CustomerDropDown name="customerId"
                  value={values.customerId}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Co Applicant</label>
                <CustomerDropDown name="CoApplicantDetails"
                  value={values.CoApplicantDetails}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Vehicle Number</label>
                <FormikInput
                  name="vehicleNumber"
                  type="text"
                  placeholder="enter Vehicle Number for filter e.g DLB64620"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Loan A/C/Policy Number</label>
                <FormikInput
                  name="LoanPolicyNumber"
                  type="text"
                  placeholder="enter Loan A/C/Policy Number"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Employment Type</label>
                <FormikSelect
                  items={EMPLOYMENT_TYPES_LIST}
                  name="employmentType"
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Invoice Recv?</label>
                <FormikToggle
                  name="invoiceRecv"
                  onlabel="Yes to go"
                  offlabel="No to go"
                  value={values.invoiceRecv}
                />
              </div>
              <div className="form-group col-md-3">
                <label>RC Recv?</label>
                <FormikToggle name="RCRecv" value={values.RCRecv} />
              </div>
              <div className="form-group col-md-3">
                <label>Insurance Received ?</label>
                <FormikToggle name="insuranceRec" value={values.insuranceRec} />
              </div>
              <div className="form-group col-md-3">
                <label>Parivahan status ?</label>
                <FormikToggle name="parivahanStatus" value={values.parivahanStatus} />
              </div>
              <div className="form-group col-md-3">
                <label>RTO Slip Received ?</label>
                <FormikToggle name="rtoSlip" value={values.rtoSlip} />
              </div>

            </div>

            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                onClear={onClear}
                resetForm={resetForm}
                submitButtonText="Search"
                submitScope="flow.case_manager.search"
              />
            </div>
          </Form>
        </div>
        {/* <div className="mb-2 border p-2 float-left">
          <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross Loan</label>
                <div>
                  <input className="text-center font-weight-bold text-black" type="text" value={grossLoan} disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Net Loan Amount</label>
                <div>
                  <input className="text-center font-weight-bold text-black" type="text" value={netLoan} disabled
                  />
                </div>
              </div>
            </span>
          </div> */}
        <SearchContainerWithPermission
          scope="flow.case_manager.search"
          editScope="flow.case_manager.search.edit"
          fallback={<UnAuthorizedErrorPage />}
          reducer="CaseReducer"
          dataPath="search"
          editAction={caseEditAction}
          redirectUrlOnEdit={RoutingUtil.caseManagerUrl()}
          action={caseSearchAction}
          hasEdit
          show={true} //to conditionally render the gross and net  
          where={where}
          queryParamsAsWhere={false}
          columns={{
            group: [
              // {
              //   display: "Date",
              //   type: Date,
              //   path: "ts",
              // },
              {
                display: "Loan Type",
                path: "meta.loanType",
              },
              {
                display: "Car Loan Type",
                path: "meta.usedCarType",
              },
              {
                display: "Bank/Company Name",
                path: "companyId.companyName",
              },
              {
                display: "Loan A/c Number",
                path: "meta.LoanAccountNo",
              },
              {
                display: "Policy Number",
                path: "coverNotes.cn_number",
              },
              {
                display: "Name Of Customer",
                path: ["customerId.firstName", "customerId.lastName"],
              },
              {
                display: "Co Applicant",
                path: ["CoApplicantDetails[0].customerId.firstName", "CoApplicantDetails[0].customerId.lastName", "CoApplicantDetails[0].customerId.phone"]
              },
              {
                display: "Cost Of Asset",
                path: "meta.costOfAsset",
              },
              {
                display: "Loan Amount",
                path: "meta.loanAmount",
              },
              {
                display: "Cross Sell Amount",
                path: "meta.crossSaleAmount",
              },
              {
                display: "Gross Loan Amount",
                path: "meta.grossLoanAmount",
              },
              {
                display: "EMI Amount",
                path: "meta.EMIAmount",
              },
              {
                display: "Advance EMI",
                path: "meta.EMIAdvance",
              },
              {
                display: "Tenure",
                path: "meta.tenure",
              },
              {
                display: "ROI",
                type: DATA_TYPE.Decimal,
                path: "meta.businessIRR",
              },
              {
                display: "Processing Fees",
                path: "meta.processingFees",
              },

              {
                display: "Disbursed Amount",
                path: "meta.disbursedAmount",
              },
              // {
              //   display: "Dealer/Showroom",
              //   path: "meta.showroomDealer.companyDisplayName",
              // },
              {
                display: "Vehicle Number",
                path: "meta.vehicleNumber",
              },
              {
                display: "Brand Name",
                path: "meta.vehicleProductId.manufacturer.companyName",
              },
              {
                display: "Model Name",
                path: "meta.vehicleProductId.productName",
              },
               {
                display: "Cubic Capacity",
                path: "meta.vehicleProductId.meta.cubicCapacity",
              },
              {
                display: "Fuel Type",
                path: "meta.vehicleProductId.meta.fuelType",
              },
              // {
              //   display: "Insurance Type",
              //   path: "vehicleStatus",
              // },
              // {
              //   display: "Insurance Plans",
              //   path: "insurancePlans",
              // },
              {
                display: "Dealer/Showroom",
                path: "meta.showroomDealer.companyDisplayName",
              },
              {
                display: "Frontend Manager",
                path: ["reportingManagerId.personalInfo.firstName", "reportingManagerId.personalInfo.lastName", "reportingManagerId.personalInfo.phone"],
              },
              {
                display: "Backend Manager",
                path: ["reportingManagerBackendId.personalInfo.firstName", "reportingManagerBackendId.personalInfo.lastName", "reportingManagerBackendId.personalInfo.phone"],
              },
              {
                display: "Assigned Agent Name",
                path: [
                  "agentId.personalInfo.firstName",
                  "agentId.personalInfo.lastName",
                  "agentId.employmentType",
                ],
              },
              // {
              //     display: 'Agent Payout Rate(%)',
              //     path: 'agentCommissionPercentage',
              // },
              // {
              //     display: 'Payout Amount',
              //     path: 'payoutAmount',
              // },
              {
                display: "Disbursement Date",
                type: Date,
                format: DATE_TIME_FORMAT.DATE,
                path: "meta.loanDate",
              },
              // { 
              //     display: 'Bank Payment Rate',
              //     path: 'companyCommissionPercentage',
              // },
              // {
              //     display: 'Due Amount',
              //     path: 'DueAmount',
              // },
              // {
              //     display: 'GST(Inc/Exc)',
              //     path: 'GSTEncExc',
              // },
              // {
              //     display: 'Difference',
              //     path: 'difference',
              // },
            ],
            productId: {
              display: "Product",
              path: "productId.productName",
            },
            InsuranceReceived: {
              display: "Invoice Received",
              path: "meta.invoiceRecv",
            },
            InvoiceReceived: {
              display: "RC Received",
              path: "meta.RCRecv",
            },
            RCReceived: {
              display: "Insurance Received",
              path: "meta.insuranceRec",
            },
            parivahanStatus: {
              display: "Parivahan Status",
              path: "meta.parivahanStatus",
            },
            rtoSlip: {
              display: "RTO Slip Received",
              path: "meta.rtoSlip",
            },
            rcTransferredBy: {
              display: "RC Transferred by",
              path: "rcTransferredBy",
            },
            by: {
              display: "By",
              path: "by.personalInfo.firstName",
            },
            updatedBy: {
              display: "Updated By",
              path: "updatedBy.personalInfo.firstName",
            },
            ts: {
              display: "Ts",
              type: Date,
              format: DATE_TIME_FORMAT.TIMEAGO,
            },
            updatedTs: {
              display: "Updated Ts",
              type: Date,
              format: DATE_TIME_FORMAT.TIMEAGO,
            },
          }}
        />
      </div>
    </div>
  );
}
// setting submit button state after submitting
const filterDefaultValues = {
  verifierId: "",
  clientId: "",
  branchId: "",
  CaseFromDate: null, //new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  CaseToDate: null, //new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  caseId: "",
  caseStatus: "",
  overAllcaseStatus: "",
  invoiceRecv: false,
  RCRecv: false,
  insuranceRec: false,
  parivahanStatus: false,
  rtoSlip:false,
};
const CaseSearchWithFilter = () => {
  const [filterInitialValues, setFilterInitialValues] = useState({
    ...filterDefaultValues,
  });
  const [where, setWhere] = useState({});
  const [grossLoan, setGrossLoan] = useState(0)
  const [netLoan, setNetLoan] = useState(0)

  // REDUX
  const dispatch = useDispatch();
  const history = useHistory();


  const onSearchSubmit = useCallback(async (values, formikUtils) => {
    formikUtils.setSubmitting(false);
  
    const {
      productCategory,
      loanType,
      usedCarLoanType,
      CaseFromDate,
      CaseToDate,
      companyId,
      agentId,
      reportingManagerId,
      reportingManagerBackendId,
      customerId,
      vehicleNumber,
      employmentType,
      invoiceRecv,
      RCRecv,
      insuranceRec,
      parivahanStatus,
      rtoSlip,
      LoanPolicyNumber,
      CoApplicantDetails,
    } = values;

    let where = {};

    // product Category
    if (productCategory)
      set(where, "productCategory", productCategory);
      if(loanType)
      set(where, "meta.loanType", loanType)
      if(usedCarLoanType)
      set(where, "meta.usedCarType", usedCarLoanType)
    // company
    if (companyId)
      set(where, "companyId", companyId);
    // FROM
    if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
      const fromDate = getStartOfDay(CaseFromDate);
      set(where, "meta.loanDate", { $gte: fromDate });
    }
    // TILL
    if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
      const tillDate = getEndOfDay(CaseToDate);
      const fromDate = getStartOfDay(CaseFromDate);
      set(where, "meta.loanDate", { $lte: tillDate });
      if (fromDate)
        set(where, "meta.loanDate", { $lte: tillDate, $gte: fromDate });
    }
//  !! used to make it strict boolean

    // invoiceRecv boolean
set(where, "meta.invoiceRecv", !!invoiceRecv);

// RCRecv boolean
set(where, "meta.RCRecv", !!RCRecv);

// insuranceRec boolean
set(where, "meta.insuranceRec", !!insuranceRec);

// parivahanStatus boolean
set(where, "meta.parivahanStatus", !!parivahanStatus);

// rtoSlip boolean
set(where, "meta.rtoSlip", !!rtoSlip);

    // CLIENT
    if (agentId) {
      where.agentId = agentId;
    //REPORTING MANAGER  
    }
    if (reportingManagerId) {
      where.reportingManagerId = reportingManagerId;
    }
    if (reportingManagerBackendId) {
      where.reportingManagerBackendId = reportingManagerBackendId;
    }
    //COAPPLICANT
    if (CoApplicantDetails) {
      set(where, "CoApplicantDetails[0].customerId", CoApplicantDetails)
    }
    //CUSTOMER
    if (customerId) {
      where.customerId = customerId;
    }
    //vehicleNumber
    if (vehicleNumber) {
      set(where, "meta.vehicleNumber", vehicleNumber);
    }
    //LoanPolicyNumber
    if (LoanPolicyNumber) {
      if (productCategory === "VEHICLE_INSURANCE")
        set(where, "coverNotes.cn_number", LoanPolicyNumber)
      else
        set(where, "meta.LoanAccountNo", LoanPolicyNumber)
    }

    if (employmentType) {
      const userType = { employmentType: employmentType };
      const users = await userSearchAPI({ where: userType });
      const userIds = users.data.data.data.map((user) => user._id);
      set(where, "agentId", { $in: userIds });
    }
    setWhere(where);

    // dispatch(
    //   caseSearchAction({
    //     where,
    //     currentPage: 0,
    //     sortBy: "ts",
    //     sortOrder: -1,
    //     fullTextSearch: false,
    //     pageLength: 10,
    //   })
    // );
  }, [])


  const onClear = useCallback(() => {
    dispatch(caseResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);
  return (
    <Formik
      onSubmit={onSearchSubmit}
      onClear={onClear}
      enableReinitialize
      initialValues={filterInitialValues}
    // validationSchema={}
    >
      {(formikProps) => (
        <Render
          // forceRefreshSearchContainer={forceRefreshSearchContainer}
          onClear={onClear}
          where={where}
          {...formikProps}
        />
      )}

    </Formik>
  );
}


export default CaseSearchWithFilter;